'use strict';

/**
 * ObstacleTransform
 * Parses and transforms an `obstacle` object into a leaflet layer via geoJSON
 */

var _ = require('lodash');
var LayerStyles = require('./lib/LayerStyles');
var Transform = require('../../../Transform');

var ObstacleTransform = Transform.extend({

  collection: 'obstacles',

  /**
   * The key on the layer under which the GeoJSON data is stored
   * @type {String}
   */
  geojsonKey: 'data',
  
  /**
   * Default layer styles for different states. Should return an object with  
   * three states (properties): active, default, dim
   * 
   * @return {Object} 
   */
  getLayerStateStyles: function (rlayer) {
    /* jshint unused:false */
    return LayerStyles.polygon;
  },

  getCollection: function (data) {
    return data.obstacles;
  },

  /**
   * Transform a layer type into a type that leaflet understands.
   * Should return one of [circle, marker, polygon, polyline, rectangle]. 
   *
   * @param  {Object} rlayer  Raw layer data
   * @return {String} type {circle|marker|polygon|polyline|rectangle}
   */
  getLeafletTypeFromLayer: function (rlayer) {
    /* jshint unused:false */
    return 'polygon';

  },

  isLayerClickable: function (rlayer) {
    /* jshint unused:false */
    return true;
  },

  isLayerEditable: function (rlayer) {
    /* jshint unused:false */
    return true;
  },

  onEachFeatureFn: function (layer, Actions, Store, feature, leafletLayer) {
    this.__super__.onEachFeatureFn.apply(this, arguments);
    
    leafletLayer.once('add', function () {
      leafletLayer.bringToFront();
    })
  },

  /**
   * This is a callback function executed when Leaflet is generating the layer 
   * and used to retrieve the LeafletLayer constructor options. 
   * 
   * @param  {Object} rlayer  Raw layer data
   * @param  {[type]} feature [description]
   * @return {[type]}         [description]
   */
  styleFn: function (rlayer, feature) {
    /* jshint unused:false */
    return _.extend({}, feature.properties.style);
  }
});

module.exports = ObstacleTransform;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/mission/obstacle/Obstacle.js